<style>
</style>

<template>

  <div class="modal-backdrop">
    <div class="modal dark-panel mt-5">
      <header class="modal-header">
        <slot name="header">
          <h1>{{trans.get('common.define_field')}}</h1>
        </slot>
        <button type="button" class="btn-close" @click="close"> x </button>
      </header>

      <section class="modal-body">
        <slot name="body">
            <form id="addpvfield" method='post' enctype='multipart/form-data' :action="routesubmit">
                <input type="hidden" name="_token" v-bind:value="csrf">
            <div class="row">
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1">
                    <div id="mapModal" class="min-h-50"><div class="menu"></div></div>
                </div>
                <div class="col-md-6 ml-sm-0 col-lg-6 pt-1 px-1 pl-5">
                    <select v-if='type=="Roof" && !pvfields' v-model="roofType" class="form-control mb-3" type="button" id="dropdownMenu1"  aria-haspopup="true" aria-expanded="true">               
                        <option>Flat roof</option>
                        <option>Pitch roof</option>
                    </select>
                    <div class="mb-3 text-left">
                        <div v-if="step===2">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">{{ trans.get('common.incline') }}</span>
                                </div>
                                <input type="number" class="form-control" placeholder="Inclinaison" aria-label="Inclinaison" aria-describedby="basic-addon1" v-model="pvFields.inclinaison">
                            </div>
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">RP</span>
                                </div>
                                <input type="number" class="form-control" aria-describedby="basic-addon1" v-model="pvFields.rp">
                            </div>                           
                        </div>
                        <div v-if="pvFields.valider===1">
                            <h5 >{{ trans.get('common.pose_type') }} :</h5>
                            <h6 id ="latitudeLabel " class="pl-5" >{{type}}</h6>
                            <h5 >{{ trans.get('common.orientation') }} :</h5>
                            <h6 id ="longitudeLabel" class="pl-5" >{{pvFields.orientation}}</h6> 
                            <h5>{{ trans.get('common.incline') }} :</h5>
                            <h6 id ="longitudeLabel" class="pl-5">{{pvFields.inclinaison}}</h6> 
                            <h5 >{{ trans.get('common.nb_modules') }} :</h5>
                            <h6 id ="longitudeLabel" class="pl-5">{{pvFields.nbModule}}</h6> 
                            <h5 >{{ trans.get('common.power') }} :</h5>
                            <h6 id ="longitudeLabel" class="pl-5">{{pvFields.puissance}}</h6>
                             <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">RP</span>
                                </div>
                                <input type="number" class="form-control" aria-describedby="basic-addon1" v-model="pvFields.rp">
                            </div>                                                        
                                 <div class="row" v-if="step===3 & !pvFields.dessiner">   
                                <button type="button" class="buttonOriginal" id="test" v-on:click="ValiderChamps()" :title="trans.get('common.validate_drawing')">
                                    <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
                                </button> 
                                <h6>{{trans.get('common.validate_drawing')}}</h6>
                            </div>

                            <div class="row" v-if="pvFields.dessiner">
                                <button type="button" class="buttonOriginal mb-3" v-on:click="pvFields.valider=2" :title="trans.get('common.display_less')">
                                    <span class="glyphicon glyphicon-minus" aria-hidden="true"></span>
                                </button>
                                <h6>{{trans.get('common.display_less')}}</h6>
                            </div>
                        </div>
                        <div v-if="pvFields.valider===2">
                            <h5 >{{ trans.get('common.field') }} N°:</h5>
                            <h6 id ="latitudeLabel" class="pl-5" >0</h6>
                            <h5 >{{ trans.get('common.power') }} :</h5>
                            <h6 id ="longitudeLabel" class="pl-5">{{pvFields.puissance}}</h6>
                            <div class="row">   
                                <button type="button" class="buttonOriginal mb-3" v-on:click="pvFields.valider=1 " :title="trans.get('common.display_more')">
                                    <span class="glyphicon glyphicon-plus" aria-hidden="true"></span>
                                </button> 
                                <h6>{{trans.get('common.display_more')}}</h6>
                            </div>
                        </div>
                        <div class="row mb-3 mx-0" v-if="step===2">
                            <button type="button" class="buttonOriginal mb-3" v-on:click="drawFields()" :title="trans.get('common.draw_fields')">
                                <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
                            </button>
                            <h6>{{trans.get('common.draw_fields')}}</h6>
                        </div>
                        <div class="row mb-3 mx-0"  v-if="step===4">
                            <div class="input-group">
                                <div class="col-md-4 ml-sm-0 col-lg-4 pt-1 px-1 pl-5" style ="text-align: right;">
                                    <h5 >{{ trans.get('common.remark') }}</h5>
                                </div>
                                <div class="col-md-8 ml-sm-0 col-lg-8 pt-1 px-1 pl-5">
                                    <input type="text" class="form-control" placeholder="Commentaire" aria-describedby="basic-addon1" name="comments" v-model="comments">
                                </div>
                            </div>
                            <div class="row">
                                <button type="button" class="buttonOriginal mb-3" v-on:click="compute()" :title="trans.get('common.validate_field')">
                                    <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
                                </button>
                                <h6>{{trans.get('common.validate_field')}}</h6>
                            </div>
                        </div>
                    </div>
                    <div class="row mb-3 mx-0" v-if="step===1">
                        <button type="button" class="buttonOriginal" v-on:click="newPvFields()" :title="trans.get('common.add')">
                            <span class="glyphicon glyphicon-ok-sign" aria-hidden="true"></span>
                        </button>
                            <h6>Ajouter un champ</h6>
                    </div>
                    <div id="saisieproductible" v-if="isProductibleModifiable==true"> 
                        <div class="input-group mb-3">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">Productible manuel :</span>
                            </div>
                            <input type="number" class="form-control" aria-describedby="basic-addon1" v-model="pvFields.productible">
                        </div>
                    </div>
                    <div class="row mb-3 mx-0 text-center">
                        <input name="data" type="hidden" id="data" style="visibility:hidden" >
                        <div class="col-md-6 col-lg-6" style="margin-left: auto; margin-right: auto;"  v-if="validated">
                            <button type="button" class="buttonOriginal" v-on:click="save()" :title="trans.get('common.save')">
                                <span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span>
                            </button>
                            <h6>{{trans.get('common.save')}}</h6>
                        </div>
                    </div>
                    <div class="row mb-3 mx-0 text-center">
                        <div class="col-md-6 col-lg-6" style="margin-left: auto; margin-right: auto;">
                            <a class="addPvLink text-blue_claire" :href='"https://maps.google.com/?ll="+latitude+","+longitude' target="_blank">Lien Google</a>
                        </div>
                        <div class="col-md-6 col-lg-6 px-0" style="margin-left: auto; margin-right: auto;">
                            <a class="addPvLink text-blue_claire" :href='"https://www.geoportail.gouv.fr/carte?c="+longitude+","+latitude+"&z=18&l0=ORTHOIMAGERY.ORTHOPHOTOS::GEOPORTAIL:OGC:WMTS(1)&l1=CADASTRALPARCELS.PARCELLAIRE_EXPRESS::GEOPORTAIL:OGC:WMTS(0.68)&permalink=yes"' target="_blank">Lien Géoportail</a>
                        </div>
                    </div>
                </div>
            </div>
            </form>
        </slot>
       </section>

      <footer class="modal-footer">
        <button type="button" class="btn btn-primary text-blue_claire" @click="close">
          {{trans.get('common.cancel')}}
        </button>
      </footer>
    </div>
  </div>
</template>


<script>

    function getCoordinates(geometry) {
        const coords = [];
        geometry.forEachLatLng(elem => {
            coords.push([elem.lng(), elem.lat()]);
        })
        coords.push(coords[0]);
        return coords;
    }

    function convertPath(path) {
        const coordinates = [];
        path.forEach(e => coordinates.push([ e.lng(), e.lat()]));
        // Set last point equal to first point
        coordinates.push(coordinates[0]);

        return {
            type: 'Feature',
            properties:{},
            geometry: {
                type: "Polygon",
                coordinates: [ coordinates ]
            }
        }
    }

    function getWesternPoint(data){
        var i = 1;
        var min = getMinLongitude(data);
        var y = 0;
        while (i<data.length){
            if(min == data[i][0]){                
                y = data[i][1];                
            }
            i++;
        }
        return [min,y];
    }

    function getSouthernPoint(data){
        var i = 1;
        var minLat = getMinLatitude(data);
        
        var y = 0;
        while (i<data.length){
            if(minLat == data[i][1]){
                
                    y = data[i][0];
                
            }
            i++;
        }
        return [y,minLat];
    }

    function getMinLatitude(data){
        var i = 1;
        var min = data[0][1];
        while (i< data.length){
            if (min> data[i][1]){
                min = data[i][1];
            }
            i++;
        }
        return min;
    }

    function getMinLongitude(data){
        var i = 1;
        var min = data[0][0];
        while (i< data.length){
            if (min> data[i][0]){
                min = data[i][0];
            }
            i++;
        }
        return min;
    }

    function getMaxLatitude(data){
        var i = 1;
        var min = data[0][1];
        while (i< data.length){
            if (min< data[i][1]){
                min = data[i][1];
            }
            i++;
        }
        return min;
    }
                
    function getMaxLongitude(data){
        var i = 1;
        var min = data[0][0];
        while (i< data.length){
            if (min< data[i][0]){
                min = data[i][0];
            }
            i++;
        }
        return min;
    }

    function validateRoofTypeOrTypeIfNotRoof (comp) {
        comp.nextPvFields=false;
        var temp = comp.parametre[comp.type == "Roof" ? comp.roofType : comp.type];
        var data =[];
        temp.forEach((element)=>{
            data[element.name]=element.value;
        });
        comp.parametreFields = data;

            
        
        var pvFields ={
            valider :0,
            inclinaison :0,
            orientation :0,
            nbModule : 0,
            puissance: 0,
            productible:0,
            champ : {},
            dessiner:false,
            rp:80,
        };
        comp.pvFields = pvFields;
        comp.step++;
    }

    function flagChanged(comp) {
        comp.validated=false;
        if(comp.step > 4) {
            comp.step = 4;
        }
    }

    export default {
        name: "addPvFieldsModal",
        props : ['zone', 'parametre', 'nameproject', "name", 'champs' , 'pvfields','appurl', 'show', 'routesubmit', 'site','mode'],     
        data : function(){
            return {
                pvFields :{
                    valider :0,
                    inclinaison :0,
                    orientation :0,
                    nbModule : 0,
                    puissance: 0,
                    productible:0,
                    champ:{},
                    dessiner:false,
                    rp:80,
                },
                othersPvFields :{
                    valider :0,
                    inclinaison :0,
                    orientation :0,
                    nbModule : 0,
                    puissance: 0,
                    productible:0,
                    champ:{},
                    dessiner:false,
                    rp:80,
                },
                GeoJsonDatas:{
                    "type": "FeatureCollection",
                    'properties':{
                        'id':'others'
                    },
                    "features": []
                },
                pvGrid:{
                    'type': 'FeatureCollection',
                    'properties':{
                        'id':'new'
                    },
                    'features': []
                },
                Mode:"",
                comments :"",
                buildingOrientation:0,
                map : {},
                pvfFieldsPolygon: null,
                nextPvFields:true,
                longitude: 0,
                latitude: 0,
                type: "",
                roofType:"Flat roof",
                idZone:"",
                parametreFields:{},
                fields: {},
                repere:{},
                step:1,
                noms:"",
                validated: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                isProductibleModifiable: false,
                overlay: {},
                idPvGridEdit:0,
            };
        },
        beforeMount: function() {
            this.Mode=this.mode;
            //récuperation des données des pvfields déjà existants
            this.othersPvFields = JSON.parse(this.champs);

            //Vérification du mode       
            if (this.Mode==="edit") {
                this.idPvGridEdit=JSON.parse(JSON.parse(this.pvfields).id);
                this.pvFields = JSON.parse(JSON.parse(this.pvfields).affichage);
                this.step = 4;//
                this.validated=true;            
            }
        },
        mounted: function(){    
            this.longitude = this.zone.longitude;
            this.latitude =this.zone.latitude;
            this.idZone=this.zone.id;
            this.type =this.zone.name;
            this.noms =this.name;
            
            const token = process.env.MIX_GOOGLE_MAP_KEY;
            const GoogleMap = require("@googlemaps/js-api-loader");

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries: ["drawing","geometry"]
            });

            loader.load().then(() => {
                // Initiate map
                this.map = new google.maps.Map(document.querySelector("#mapModal"), {
                    center: { lat: this.latitude, lng: this.longitude },
                    zoom: 19,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    heading: 0,
                    tilt: 0,
                    mapId: "90f87356969d889c",
                });                         
               
                const { getCadastreLayer, getPLULayer, getOverlayControls } = require("../maps/additional-layers.js");
                const { EnedisHTLines, EnedisBTLines, EnedisDeliveryPosts, EnedisSourcePosts, RteLines, RtePylones, RtePostes } = require("../maps/opendata-carto-module.js");

                const overlaysMenu = getOverlayControls({
                    'cadastre': getCadastreLayer(),
                    'urbanism': getPLULayer(this.map),
                    'ht-lines': new EnedisHTLines(this.longitude, this.latitude, 1),
                    'bt-lines': new EnedisBTLines(this.longitude, this.latitude, 1),
                    'posts': new EnedisDeliveryPosts(this.longitude, this.latitude, 1),
                    'source-posts': new EnedisSourcePosts(this.longitude, this.latitude, 1),
                    'rte-posts': new RtePostes(this.longitude, this.latitude, 5),
                    'rte-lines': new RteLines(this.longitude, this.latitude, 5),
                    'rte-pylones': new RtePylones(this.longitude, this.latitude, 5),
                }, this.map);

                const menu = document.createElement("div");
                menu.className = "menu menu-right";
                const Regle = require("../maps/regle.js");
                const menuRegle = new Regle.default(this.map);
                menu.appendChild(menuRegle.getItemMenu());
                
                const Surface = require("../maps/surface.js");
                const menuSurface = new Surface.default(this.map);
                menu.appendChild(menuSurface.getItemMenu());

                this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(menu);
                this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(overlaysMenu);

                var zoomRangeModifier = this.map.__proto__.__proto__.__proto__;
                var originalSetFunc = zoomRangeModifier.set;
                var hijackedSetFunc = function(name, value) {
                    if (name === 'maxZoom') {
                        value = 21;
                    }
                    originalSetFunc.call(this, name, value);
                };
                zoomRangeModifier.set = hijackedSetFunc;

                if(this.site.imageplan) {
                    var imageplan = this.site.imageplan;
                    const ImagePlanOverlay = require("../maps/imagePlanOverlay.js");
                    const sw = JSON.parse(this.site.imageplan.southwest);
                    const ne = JSON.parse(this.site.imageplan.northeast);
                    const bounds = new google.maps.LatLngBounds(
                    new google.maps.LatLng(sw.lat, sw.lng),
                    new google.maps.LatLng(ne.lat, ne.lng)
                    );
                    this.overlay = new ImagePlanOverlay.default(bounds, imageplan.image, imageplan.rotationAngle);

                    this.overlay.setMap(this.map);
                }


                this.drawingManager = new google.maps.drawing.DrawingManager({
                    drawingMode: google.maps.drawing.OverlayType.POLYGON,
                    drawingControl: true,
                    drawingControlOptions: {
                        position: google.maps.ControlPosition.TOP_CENTER,
                        drawingModes: [google.maps.drawing.OverlayType.POLYGON]
                    },
                    polygonOptions:{
                        fillColor : "#FF0000",
                        strokeColor: "#FF0000",
                        strokeOpacity: 1,
                        draggable: true,
                    }
                });

                // Initiate base marker
                const siteMarker = new google.maps.Marker({
                    position: { lng: this.longitude, lat: this.latitude },
                    map: this.map,
                    draggable: false,
                    label: {
                        color: "white",
                        fontWeight: "bold",
                        text: "Site",
                    },
                    icon: {
                        url: "/image/maps/marker_blue.png",
                        labelOrigin: new google.maps.Point(11, 50),
                        size: new google.maps.Size(25, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(11, 40),
                    },
                });
                this.initFields();
                this.map.data.addGeoJson(this.GeoJsonDatas);//charge tous les pvFields dans la/les feature(s) collection(s)               
                //Vérification du mode 
                if (this.Mode==="edit") {
                    var temp = this.parametre[this.type == "Roof" ? this.roofType : this.type];
                    var data =[];
                    temp.forEach((element)=>{
                        data[element.name]=element.value;
                    });
                    this.parametreFields = data;
                    this.map.data.addGeoJson(this.pvGrid);
                    this.displayPvFields();
                } else if (this.type != "Roof") {
                    validateRoofTypeOrTypeIfNotRoof(this);
                }
                    
                //modifie dynamiquement le style des polygons en fonction de leur nom                    
                this.map.data.setStyle(function(feature) {                        
                    var name = feature.getProperty('name');                       
                    var color = name !='others' ? '#000f45':'#39FF14';
                    var drag= name !='others'? true : false;                  
                    return {
                        fillColor: color,
                        fillOpacity: 0.8,
                        strokeWeight: 0,
                        draggable:drag,
                        clickable:drag,
                    };
                }); 
            });          
        },
        methods :{
            /**
             *  en mode add: ajoute la liste de features déjà existante (base de donnée) dans la featuresCollection:'GeoJsonData' 
             *  en mode edit: sépare la liste de features dans deux featuresCollections: celle que l'on souhaite editer dans this.pvGrid et toutes les autres dans this.GeoJsonData
             */
             initFields(){
            
                //on affiche les autres champs seulement si li y en a d'autres
                if (this.champs){
                    //en mode edition on sépare les données en deux parties: les données du champ que l'on souhaite editer (this.pvGrid) et toutes les autres(GeoJsonDatas)
                    if (this.Mode==="edit"){

                        var data = [];
                        var dataEditable = [];

                        this.othersPvFields.forEach(element => {                                                 
                            if(element.id!=this.idPvGridEdit){
                                data.push(JSON.parse(element.affichage));
                            }
                            else{
                                dataEditable.push(JSON.parse(element.affichage));
                            }
                        });

                        //Reformatage des données des pvfiedlds
                        data.forEach(element => {     
                            element.champ.features.forEach(feature => {                           
                                var pv = {
                                    'type': 'Feature',
                                    'properties':{
                                        'name':'others',
                                    },
                                    'geometry':feature.geometry,
                                };                           
                                this.GeoJsonDatas.features.push(pv);//ajout dans la collection de features
                            });                      
                        });         
                        //Reformatage des données des pvfiedlds
                        dataEditable.forEach(element => {     
                            element.champ.features.forEach(feature => {                           
                                var pvEdit = {
                                    'type': 'Feature',
                                    'properties':{
                                        'name':'new',
                                    },
                                    'geometry':feature.geometry,
                                };                           
                                this.pvGrid.features.push(pvEdit);//ajout dans la collection de features
                            });                      
                        });
                        
                    }else{
                        var data = [];
                   
                        this.othersPvFields.forEach(element => {                       
                            data.push(JSON.parse(element.affichage));
                        });

                        //Reformatage des données des pvfiedlds
                        data.forEach(element => {     
                            element.champ.features.forEach(feature => {                           
                                var pv = {
                                    'type': 'Feature',
                                    'properties':{
                                        'name':'others',
                                    },
                                    'geometry':feature.geometry,
                                };                           
                                this.GeoJsonDatas.features.push(pv);//ajout dans la collection de features
                            });                      
                        });                       
                    }                                     
                }               
            },
            ajouterBouttoncorbeille(){
                // Delete shape button
                const div = document.createElement("div");
                div.id = "deletePolygon";
                div.classList = "gmnoprint button-control";
                div.innerHTML = `<button style="display: block; border: 0px none; margin: 0px; text-transform: none; appearance: none; position: relative; cursor: pointer; user-select: none; direction: ltr; overflow: hidden; text-align: left; color: rgb(86, 86, 86); font-family: Roboto, Arial, sans-serif; font-size: 11px; border-bottom-left-radius: 2px; border-top-left-radius: 2px; box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;" draggable="false" aria-label="Arrêter de dessiner" title="Arrêter de dessiner" type="button" role="menuitemradio" aria-checked="false">
                    <span style="display: inline-block;">
                        <div style="overflow: hidden; position: relative;">
                            <img src="/image/trash.svg" draggable="false">
                        </div>
                    </span>
                </button>`

                this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(div);

                div.querySelector("img").onclick = (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    e.stopPropagation();
                
                    if (this.pvfFieldsPolygon) {
                        this.pvfFieldsPolygon.setMap(null);
                        this.drawingManager.setDrawingMode(google.maps.drawing.OverlayType.POLYGON);
                        //lors du click sur le bouton "corbeille" on retire également les panneaux qui etait en train d'être placés
                        this.map.data.forEach(feature => {                       
                            if (feature.getProperty('name')==='new') {
                                this.map.data.remove(feature);
                            }
                        });
                        //et on relance l'outil de dessin
                        
                    }
                    this.drawingManager.setMap(this.map);
                }
            },                           
            close() {
                this.$emit('close');
            },
            getDistanceModule() {
               return parseFloat(this.parametreFields['Espace Longueur Module']);
            },
            getEcartModule() {
                return  parseFloat(this.parametreFields['Espace Largeur Shed']);
            },
            getModuleHeight() {
                return parseFloat(this.parametreFields['Longueur Module'])*parseFloat(this.parametreFields['Nombre de Module en Largeur']) +
                    parseFloat(this.parametreFields['Espace Longueur Module'])*(parseFloat(this.parametreFields['Nombre de Module en Largeur'])-1);
            },
            getModuleWidth() {
                return parseFloat(this.parametreFields['Largeur Module'])*parseFloat(this.parametreFields['Nombre de Module en Longueur']) +
                    parseFloat(this.parametreFields['Espace Longueur Module'])*(parseFloat(this.parametreFields['Nombre de Module en Longueur'])-1);
            },
            async compute(){
                var temp2 = this.nameproject;
                var type = "json";
                var puissance = this.pvFields.puissance;
                var caracteristique = "lat=" + this.latitude 
                +"&lon="+ this.longitude 
                +"&peakpower="+this.pvFields.puissance
                +"&loss="+(100-this.pvFields.rp)
                +"&angle="+ this.pvFields.inclinaison
                +"&aspect="+this.pvFields.orientation
                +"&outputformat="+type;
                
                var productible = 1;               
                await axios({
                    method: 'post',
                    baseURL: this.appurl,
                    url: '/field/productible/'+this.idZone,
                    data : caracteristique,
                }).then((response)=>{  
                    if(response.data.outputs == undefined) {
                        this.isProductibleModifiable = true;
                    } else {
                        productible=response.data.outputs.totals.fixed.E_y/puissance;
                    }
                    this.validated=true;
                });                                              
                this.pvFields.productible=productible;
                this.step++;
            },
            save(){
                var data_array =[];
                if(this.type=="Roof"){
                    data_array.push({
                        nbModule : this.pvFields.nbModule,
                        orientation : this.pvFields.orientation,
                        inclinaison : this.pvFields.inclinaison,
                        productible : this.pvFields.productible,
                        puissance : this.pvFields.puissance,
                        affichage : JSON.stringify(this.pvFields),
                        typePose: this.roofType,
                        building_ID: this.idZone,
                        comments: this.comments,
                        nom :this.noms,
                        rp : this.pvFields.rp,
                    });
                }else{
                    data_array.push({
                        nbModule : this.pvFields.nbModule,
                        orientation : this.pvFields.orientation,
                        inclinaison : this.pvFields.inclinaison,
                        productible : this.pvFields.productible,
                        rp : this.pvFields.rp,
                        puissance : this.pvFields.puissance,
                        affichage : JSON.stringify(this.pvFields),
                        typePose: this.type,
                        building_ID: this.idZone,
                        comments: this.comments,
                        nom :this.noms,
                    });
                }
                document.getElementById('data').value = JSON.stringify(data_array);
                
                document.getElementById("addpvfield").submit();
                
            },
            newPvFields(){
                validateRoofTypeOrTypeIfNotRoof(this);
            },
            drawFields(){

                this.drawingManager.setMap(this.map);
                this.step++;
                this.pvFields.valider = 1;

                google.maps.event.addListener(this.drawingManager, 'polygoncomplete', (polygon) => {
                                      
                    const firstPoint = [ polygon.getPath().getAt(0).lng(), polygon.getPath().getAt(0).lat() ];
                    const secondPoint = [ polygon.getPath().getAt(1).lng(), polygon.getPath().getAt(1).lat() ];
                    this.buildingOrientation = turf.bearing(secondPoint, firstPoint);

                    this.pvfFieldsPolygon = polygon;

                    polygon.setEditable(true);
                    polygon.setDraggable(true);

                    //determine et affiche les features
                    this.validerImplantation();

                    //quand le polygone est terminé on retire l'outil de dessin
                    this.drawingManager.setDrawingMode(null);

                    this.ajouterBouttoncorbeille();

                    google.maps.event.addListener(this.pvfFieldsPolygon, 'drag', () => {
                        // add pvgrid from map just once when dragging has ended.
                        this.map.data.forEach(feature => {                       
                            if (feature.getProperty('name')==='new') {
                                this.map.data.remove(feature);
                            }
                        });
                        this.validerImplantation();
                    });
                    
                    google.maps.event.addListener(this.pvfFieldsPolygon, 'mouseup', () => {
                        // add pvgrid from map just once when dragging has ended.
                        this.map.data.forEach(feature => {                       
                            if (feature.getProperty('name')==='new') {
                                this.map.data.remove(feature);
                            }
                        });
                        this.validerImplantation();
                        
                    });
                   
                });

            },
            /**
             * Détermine et implante les pvFields en fonction du polygon définit par l'utilisateur avec l'outil de dessin (drawingManager)
             */
            validerImplantation(){       
                this.pvGrid.features=[];        
                this.pvFields.orientation  = Math.round(this.buildingOrientation);
                
                var orientation = parseFloat(this.pvFields.orientation);
                
                if(orientation == -180){
                    orientation ==180;
                }

                var inclinaison = parseFloat(this.pvFields.inclinaison);
                var distanceSécurité = parseFloat(this.parametreFields['Distance Securite']);
                var moduleHeight = this.getModuleHeight();
                var moduleWidth = this.getModuleWidth();
                var distanceModule = this.getDistanceModule();
                var ecartModule = this.getEcartModule();
                    
                if(orientation<=90 & orientation>=0){
                            //                        45           -45              135             -135
                        var arrayOrientation = [orientation, orientation-90, orientation+90, orientation-180];
                }else if (orientation>90){
                                //                    45             -45               135          -135
                         var temp = -orientation;
                        var arrayOrientation = [temp+90, temp, temp+180, temp+270];
                        
                }else if (orientation<0 & orientation>=-90){
                                //                              45                  -45                 135                             -135
                        var arrayOrientation = [orientation, orientation-90, orientation+90, orientation+180];
                }else{
                            //                         45               -45             135            -135
                    //var arrayOrientation = [orientation+180,orientation+90, orientation+270, orientation];
                    var temp = Math.abs(orientation);
                    var arrayOrientation = [temp-270,temp, temp-180, temp-90];
                }

                var data = convertPath(this.pvfFieldsPolygon.getPath());
                
                var coord1 = data.geometry.coordinates[0];
                var point1 = coord1[1];
                var limitPV = {};
                    
                arrayOrientation.forEach(element=>{
                        
                        if(_.isEmpty(limitPV)){
                            limitPV = turf.transformTranslate(data,distanceSécurité/1000,element);
                            limitPV = turf.intersect(limitPV,data);
                            
                        }else{
                            limitPV = turf.intersect(limitPV,turf.transformTranslate(limitPV,distanceSécurité/1000,element));
                            if(limitPV!=null){
                                if(turf.intersect(limitPV,data)!=null){
                                    limitPV = turf.intersect(limitPV,data);
                                }
                            }
                        }
                    });
               
                if(limitPV!=null) {
                    var i=0;
                    var j = 0;
                    var nearestPoint = limitPV.geometry.coordinates[0][i];

                    while (
                        i < limitPV.geometry.coordinates[0].length - 1
                       
                    ) {
                       if(turf.distance(point1,nearestPoint)>turf.distance(point1, limitPV.geometry.coordinates[0][i+1])){
                           nearestPoint=limitPV.geometry.coordinates[0][i+1];
                           j = i+1;
                       } 
                       i++;
                    }
                }
                    
                var point2 = limitPV.geometry.coordinates[0][j];
                var point3 = limitPV.geometry.coordinates[0][j+1];
                   
                if(i ==0){
                    var temp = limitPV.geometry.coordinates[0]
                    var point4 = temp[temp.length-2];
                }else{
                    var point4 = limitPV.geometry.coordinates[0][i-1];
                }
                   
                var maxLat = getMaxLatitude(data.geometry.coordinates[0]);
                var minLat = getMinLatitude(data.geometry.coordinates[0]);
                var maxLong = getMaxLongitude(data.geometry.coordinates[0]);
                var minLong = getMinLongitude(data.geometry.coordinates[0]);
                    
                var test = turf.transformRotate(turf.bboxPolygon([minLong,minLat, maxLong, maxLat]),orientation);
                if(orientation!=0 && orientation!=180){
                    while(turf.booleanContains(test,data)==false){
                        var maxLat = getMaxLatitude(test.geometry.coordinates[0]);
                        var minLat = getMinLatitude(test.geometry.coordinates[0]);
                        var maxLong = getMaxLongitude(test.geometry.coordinates[0]);
                        var minLong = getMinLongitude(test.geometry.coordinates[0]);
                        test = turf.transformRotate(turf.bboxPolygon([minLong,minLat, maxLong, maxLat]),orientation);
                    }
                }
                var clockWise = turf.booleanClockwise(turf.lineString(turf.coordAll(data)));
                var coordPVmodule = [];
                var orientationX = 0;
                var orientationY = 0;
                if(orientation<0){
                        point2 = getSouthernPoint(test.geometry.coordinates[0]);
                        if(clockWise){
                                if(orientation<-90){
                                    orientationX = orientation +270;
                                    orientationY = orientationX + 90;
                                    coordPVmodule.push(point2);
                                    var temp = turf.destination(point2,moduleWidth/1000,orientationX).geometry.coordinates;
                                    coordPVmodule.push(temp);
                                    
                                    temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY+180).geometry.coordinates;

                                    coordPVmodule.push(temp);
                                    temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY+180).geometry.coordinates;
                                    coordPVmodule.push(temp);

                                    coordPVmodule.push(point2);

                                }else{
                                    orientationX = orientation-90;
                                    orientationY = orientation;
                                    coordPVmodule.push(point2);
                                    var temp = turf.destination(point2,moduleWidth/1000,orientationX+180).geometry.coordinates;
                                    coordPVmodule.push(temp);
                                    
                                    temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                    coordPVmodule.push(temp);
                                    temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                    coordPVmodule.push(temp);

                                    coordPVmodule.push(point2);
                                }

                        }else{
                                if(orientation<-90){
                                    orientationX = orientation+90;
                                    orientationY = orientation;
                                    coordPVmodule.push(point2);
                                    var temp = turf.destination(point2,moduleWidth/1000,orientationX).geometry.coordinates;
                                    coordPVmodule.push(temp);
                                    
                                    temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY+180).geometry.coordinates;

                                    coordPVmodule.push(temp);
                                    temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY+180).geometry.coordinates;
                                    coordPVmodule.push(temp);

                                    coordPVmodule.push(point2);

                                }else{
                                    orientationX = orientation+90;
                                    orientationY = orientation;
                                    coordPVmodule.push(point2);
                                    var temp = turf.destination(point2,moduleWidth/1000,orientationX).geometry.coordinates;
                                    coordPVmodule.push(temp);
                                    
                                    temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                    coordPVmodule.push(temp);
                                    temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                    coordPVmodule.push(temp);

                                    coordPVmodule.push(point2);
                                }
                        }

                }else{

                        point2 = getWesternPoint(test.geometry.coordinates[0]);
                        if(clockWise){
                            if(orientation>90){
                                orientationX = orientation-90;
                                orientationY = orientation;
                                coordPVmodule.push(point2);
                                var temp = turf.destination(point2,moduleWidth/1000,orientationX).geometry.coordinates;
                                coordPVmodule.push(temp);
                                
                                temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                coordPVmodule.push(temp);
                                temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                coordPVmodule.push(temp);

                                coordPVmodule.push(point2);

                            }else{
                                orientationX = orientation-90;
                                orientationY = orientation;
                                coordPVmodule.push(point2);
                                var temp = turf.destination(point2,moduleWidth/1000,orientationX-180).geometry.coordinates;
                                coordPVmodule.push(temp);
                                
                                temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                coordPVmodule.push(temp);
                                temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                coordPVmodule.push(temp);

                                coordPVmodule.push(point2);
                            }
                                

                        }else{
                            if(orientation>90){
                                orientationX = orientation-270;
                                orientationY = orientation-360;
                                coordPVmodule.push(point2);
                                var temp = turf.destination(point2,moduleWidth/1000,orientationX-180).geometry.coordinates;
                                coordPVmodule.push(temp);
                                
                                temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                coordPVmodule.push(temp);
                                temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                coordPVmodule.push(temp);

                                coordPVmodule.push(point2);

                            }else{

                                orientationX = orientation+90;
                                orientationY = orientation;

                                coordPVmodule.push(point2);
                                var temp = turf.destination(point2,moduleWidth/1000,orientationX).geometry.coordinates;
                                coordPVmodule.push(temp);
                                
                                temp = turf.destination(temp,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;

                                coordPVmodule.push(temp);
                                temp = turf.destination(point2,moduleHeight*Math.cos(inclinaison*Math.PI/180)/1000,orientationY).geometry.coordinates;
                                coordPVmodule.push(temp);

                                coordPVmodule.push(point2);
                            }
                        }

                }

                var pvMod = turf.polygon([coordPVmodule]);
                
                var distX = (moduleWidth+distanceModule)/1000;
                var distY= (moduleHeight+ecartModule)*Math.cos(inclinaison*Math.PI/180)/1000;

                var xMax =0;
                var yMax = 0;

                if(orientation>=0){
                    if(clockWise){
                        if(orientation<=90){
                            orientationX = orientationX-180;

                            xMax = getMinLatitude(test.geometry.coordinates[0]);
                            yMax = getMaxLatitude(test.geometry.coordinates[0]);
                        }else{
                            xMax = getMaxLatitude(test.geometry.coordinates[0]);
                            yMax = getMinLatitude(test.geometry.coordinates[0]);
                        }
                    }else{
                        
                        if(orientation>90){
                            orientationX = orientationX-180;
                            xMax = getMaxLatitude(test.geometry.coordinates[0]);
                            yMax = getMinLatitude(test.geometry.coordinates[0]);
                        }else{
            
                            xMax = getMinLatitude(test.geometry.coordinates[0]);
                            yMax = getMaxLatitude(test.geometry.coordinates[0]);
                        }
                    }

                }else{
                    if(clockWise){
                        if(orientation<-90){
                            orientationY=orientationY+180;
                            orientationX=orientationX+180;
                            xMax = getMinLongitude(test.geometry.coordinates[0]);
                            yMax = getMaxLongitude(test.geometry.coordinates[0]);
                        }else{
                            orientationX=orientationX+180;
                            xMax = getMaxLongitude(test.geometry.coordinates[0]);
                            yMax = getMinLongitude(test.geometry.coordinates[0]);
                        }
                    }else{
                        if(orientation<-90){
                            orientationY=orientationY+180;
                            xMax = getMinLongitude(test.geometry.coordinates[0]);
                            yMax = getMaxLongitude(test.geometry.coordinates[0]);
                        }else{
                            xMax = getMaxLongitude(test.geometry.coordinates[0]);
                            yMax = getMinLongitude(test.geometry.coordinates[0]);
                        }
                    }

                }

                
                pvMod = turf.transformTranslate(pvMod,0.5/1000,orientationY);
                pvMod = turf.transformTranslate(pvMod,0.5/1000,orientationX);


                var pvModule = {
                    'type': 'Feature',
                    'properties':{ 
                        'id' : 'pv module',
                        'name':'new',                 
                    },
                    'geometry': {
                        'type': 'Polygon',
                        'coordinates': pvMod.geometry.coordinates
                    }
                };
                if(orientation >=0 && orientation<90 ){
                    if(orientation==0){
                        while(getMinLatitude(pvMod.geometry.coordinates[0])>xMax && turf.booleanContains(test, pvMod)){
                            var temp=pvMod;

                            while(getMaxLatitude(temp.geometry.coordinates[0])<yMax && turf.booleanContains(test, temp)){
                                
                                var temp2 = turf.transformTranslate(temp,distY,orientationY)
                                temp=temp2;
                                if(turf.booleanContains(limitPV,temp2)){
                                    var pvModule = {
                                        'type': 'Feature',
                                        'properties':{ 
                                            'id' : 'pv module',
                                            'name':'new',
                                        },
                                        'geometry': {
                                            'type': 'Polygon',
                                            'coordinates': temp2.geometry.coordinates

                                        }
                                    };
                                    this.pvGrid.features.push(pvModule);
                                }

                            }
                        
                            pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                            if(turf.booleanContains(limitPV,pvMod)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': pvMod.geometry.coordinates
                                    }
                                };
                                this.pvGrid.features.push(pvModule);
                            }

                        }
                    }else{
                       
                        while(getMinLatitude(pvMod.geometry.coordinates[0])>xMax){
                            var temp=pvMod;

                            while(getMaxLatitude(temp.geometry.coordinates[0])<yMax && turf.booleanContains(test, temp)){
                                var temp2 = turf.transformTranslate(temp,distY,orientationY);
                                temp=temp2;
                                if(turf.booleanContains(limitPV,temp2)){
                                    var pvModule = {
                                        'type': 'Feature',
                                        'properties':{ 
                                            'id' : 'pv module',
                                            'name':'new',
                                        },
                                        'geometry': {
                                            'type': 'Polygon',
                                            'coordinates': temp2.geometry.coordinates

                                        }                                   
                                    };
                                    this.pvGrid.features.push(pvModule);
                                }

                            }
                            
                            pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                            if(turf.booleanContains(limitPV,pvMod)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': pvMod.geometry.coordinates

                                    }                               
                                };
                                this.pvGrid.features.push(pvModule);
                            }  

                        }
                    }
                }else if(orientation > 90){
                    if(orientation==180 ){
                        while(getMaxLatitude(pvMod.geometry.coordinates[0])<xMax && turf.booleanContains(test, pvMod)){
                            var temp=pvMod;

                            while(getMinLatitude(temp.geometry.coordinates[0])>yMax  && turf.booleanContains(test, temp)){
                                var temp2 = turf.transformTranslate(temp,distY,orientationY)
                                temp=temp2;
                                if(turf.booleanContains(limitPV,temp2)){
                                    var pvModule = {
                                        'type': 'Feature',
                                        'properties':{ 
                                            'id' : 'pv module',
                                            'name':'new',
                                        },
                                        'geometry': {
                                            'type': 'Polygon',
                                            'coordinates': temp2.geometry.coordinates

                                        }                                    
                                    };
                                    this.pvGrid.features.push(pvModule);
                                }

                            }                       
                            pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                            if(turf.booleanContains(limitPV,pvMod)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': pvMod.geometry.coordinates
                                    }                               
                                };
                                this.pvGrid.features.push(pvModule);
                            } 

                        }
                    }else{
                        while(getMaxLatitude(pvMod.geometry.coordinates[0])<xMax ){
                            var temp=pvMod;

                            while(getMinLatitude(temp.geometry.coordinates[0])>yMax  && turf.booleanContains(test, temp)){
                                var temp2 = turf.transformTranslate(temp,distY,orientationY)
                                temp=temp2;
                                if(turf.booleanContains(limitPV,temp2)){
                                    var pvModule = {
                                        'type': 'Feature',
                                        'properties':{ 
                                            'id' : 'pv module',
                                            'name':'new',
                                        },
                                        'geometry': {
                                            'type': 'Polygon',
                                            'coordinates': temp2.geometry.coordinates
                                        }
                                        
                                    };
                                    this.pvGrid.features.push(pvModule);
                               }
                            }
                        
                            pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                            if(turf.booleanContains(limitPV,pvMod)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': pvMod.geometry.coordinates
                                    }
                                
                                };
                                this.pvGrid.features.push(pvModule);
                            }
                            
                        }
                    }
                        
                }else if(orientation<0 && orientation>=-90){
                    while(getMaxLongitude(pvMod.geometry.coordinates[0])<xMax){
                        var temp=pvMod;
                        
                        while(getMinLongitude(temp.geometry.coordinates[0])>yMax  && turf.booleanContains(test, temp)){
                            var temp2 = turf.transformTranslate(temp,distY,orientationY)
                            temp=temp2;
                            if(turf.booleanContains(limitPV,temp2)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': temp2.geometry.coordinates
                                    }
                                
                                };
                                this.pvGrid.features.push(pvModule);
                            }
                        }
                    
                        pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                        if(turf.booleanContains(limitPV,pvMod)){
                            var pvModule = {
                                'type': 'Feature',
                                'properties':{ 
                                    'id' : 'pv module',
                                    'name':'new',
                                },
                                'geometry': {
                                    'type': 'Polygon',
                                    'coordinates': pvMod.geometry.coordinates
                                }
                            
                            };
                            this.pvGrid.features.push(pvModule);
                        }
                        
                    }
                }else{
                    while(getMinLongitude(pvMod.geometry.coordinates[0])>xMax){
                        var temp=pvMod;

                        while(getMaxLongitude(temp.geometry.coordinates[0])<yMax  && turf.booleanContains(test, temp)){
                            var temp2 = turf.transformTranslate(temp,distY,orientationY)
                            temp=temp2;
                            if(turf.booleanContains(limitPV,temp2)){
                                var pvModule = {
                                    'type': 'Feature',
                                    'properties':{ 
                                        'id' : 'pv module',
                                        'name':'new',
                                    },
                                    'geometry': {
                                        'type': 'Polygon',
                                        'coordinates': temp2.geometry.coordinates
                                    }
                                
                                };
                                this.pvGrid.features.push(pvModule);
                            }
                        }
                        pvMod = turf.transformTranslate(pvMod,distX,orientationX);
                        if(turf.booleanContains(limitPV,pvMod)){
                            var pvModule = {
                                'type': 'Feature',
                                'properties':{ 
                                    'id' : 'pv module',
                                    'name':'new',
                                },
                                'geometry': {
                                    'type': 'Polygon',
                                    'coordinates': pvMod.geometry.coordinates
                                }
                            
                            };
                           
                            this.pvGrid.features.push(pvModule);
                        }
                        
                    }
                }                                
                this.pvFields.nbModule = this.pvGrid.features.length*parseFloat(this.parametreFields['Nombre de Module en Longueur'])*parseFloat(this.parametreFields['Nombre de Module en Largeur']);
                this.pvFields.puissance= this.pvFields.nbModule*parseFloat(this.parametreFields['Puissance'])/1000;

                this.map.data.addGeoJson(this.pvGrid);                 
            },
            /**
             * fonction de transition entre drawFields() et display() 
             */
            ValiderChamps(){               
                this.pvFields.dessiner=true;
                this.step++;

                this.pvFields.valider=2;
                
                this.pvFields.champ = this.pvGrid;
                this.nextPvFields=true;

                document.querySelector("#deletePolygon").remove();
                this.drawingManager.setMap(null);
                this.pvfFieldsPolygon?.setMap(null);
                
                this.displayPvFields();
            },
            displayPvFields() {              
                var coord = [];
                var tempModule = null;

                let isAddition = false;
                let isRemove = false;

                const menu = document.createElement("div");
                menu.className = "menu menu-right";

                const addPvLink = document.createElement("a");
                addPvLink.textContent = "+"
                addPvLink.className ='inactive';
                addPvLink.href ="#";
                addPvLink.id="+";
                addPvLink.title=trans.get('common.add');
                menu.appendChild(addPvLink);

                const removePvLink = document.createElement("a");
                removePvLink.textContent = "-"
                removePvLink.href ="#";
                removePvLink.className ="inactive";
                removePvLink.id="-";
                removePvLink.title=trans.get('common.remove');
                menu.appendChild(removePvLink);

                const rotateRight = document.createElement("a");
                rotateRight.href = "#";
                rotateRight.textContent = "⟳";
                rotateRight.title=trans.get('common.rotate_right');
                menu.appendChild(rotateRight);

                const rotateLeft = document.createElement("a");
                rotateLeft.href = "#";
                rotateLeft.textContent = "⟲";
                rotateLeft.title=trans.get('common.rotate_left');
                menu.appendChild(rotateLeft);

                rotateRight.onclick = () => {
                    const pivot = turf.centroid(this.pvGrid);

                    this.pvGrid.features.forEach(feature => {
                        turf.transformRotate(feature, 1, {
                            pivot,
                            mutate: true
                        });
                    });

                    this.pvFields.orientation++;

                    //refresh de la map
                    this.map.data.forEach(e =>this.map.data.remove(e));
                    this.map.data.addGeoJson(this.pvGrid);   
                    this.map.data.addGeoJson(this.GeoJsonDatas);

                    flagChanged(this);
                };

                rotateLeft.onclick = () => {
                    const pivot = turf.centroid(this.pvGrid);

                    this.pvGrid.features.forEach(feature => {
                        turf.transformRotate(feature, -1, {
                            pivot,
                            mutate: true
                        });
                    });

                    this.pvFields.orientation--;

                    //refresh de la map
                    this.map.data.forEach(e => this.map.data.remove(e));                  
                    this.map.data.addGeoJson(this.pvGrid);   
                    this.map.data.addGeoJson(this.GeoJsonDatas);

                    flagChanged(this);
                };

                const removeFromPvGrid = (e) => {
                    coord = [e.latLng.lng() ,e.latLng.lat()];
                    var i = 0;
                    while (turf.booleanContains(this.pvGrid.features[i],turf.point(coord)) === false){
                        i++;
                    }
                    this.pvGrid.features.splice(i,1);
                }

                var orientation = parseFloat(this.pvFields.orientation);

                const moduleWidth = this.getModuleWidth();
                const moduleHeight = this.getModuleHeight();

                var distX = (moduleWidth + this.getDistanceModule()) / 1000;
                var distY=  (moduleHeight + this.getEcartModule()) * Math.cos( this.pvFields.inclinaison*Math.PI/180)/1000;
            
                if(orientation<=90 & orientation>=0){
                                //                        45           -45              135             -135
                    var arrayOrientation = [
                        {"orientation": orientation,"distance":distY},
                        {"orientation": orientation-90,"distance":distX},
                        {"orientation": orientation+90,"distance":distX},
                        {"orientation": orientation-180,"distance":distY},
                    ]
                }else if (orientation>90){
                                    //                    45             -45               135          -135
                    var temp = orientation-180;
                    var arrayOrientation = [
                        {"orientation": temp,"distance":distY},
                        {"orientation": temp-90,"distance":distX},
                        {"orientation": temp+90,"distance":distX},
                        {"orientation": temp+180,"distance":distY},
                    ]
                        
                }else if (orientation<0 & orientation>=-90){
                                    //                              45                  -45                 135                             -135
                    var arrayOrientation = [
                        {"orientation": orientation+180,"distance":distY},
                        {"orientation": orientation-90,"distance":distX},
                        {"orientation": orientation+90,"distance":distX},
                        {"orientation": orientation,"distance":distY},
                    ]
                }else{
                                    //                         45               -45             135            -135
                    var temp = orientation +180;
                    var arrayOrientation = [
                        {"orientation": temp,"distance":distY},
                        {"orientation": temp-90,"distance":distX},
                        {"orientation": temp+90,"distance":distX},
                        {"orientation": temp-180,"distance":distY},
                    ]
                }

                this.map.addListener('click', (e) => {

                    if (tempModule && isAddition) {
                        
                        var orientation = parseFloat(this.pvFields.orientation);
                        if(orientation<=90 & orientation>=0){
                                    //                        45           -45              135             -135
                            var arrayOrientation = [
                                {"orientation": orientation,"distance":distY},
                                {"orientation": orientation-90,"distance":distX},
                                {"orientation": orientation+90,"distance":distX},
                                {"orientation": orientation-180,"distance":distY},
                            ]
                        }else if (orientation>90){
                                            //                    45             -45               135          -135
                            var temp = orientation-180;
                            var arrayOrientation = [
                                {"orientation": temp,"distance":distY},
                                {"orientation": temp-90,"distance":distX},
                                {"orientation": temp+90,"distance":distX},
                                {"orientation": temp+180,"distance":distY},
                            ]
                                
                        }else if (orientation<0 & orientation>=-90){
                                            //                              45                  -45                 135                             -135
                            var arrayOrientation = [
                                {"orientation": orientation+180,"distance":distY},
                                {"orientation": orientation-90,"distance":distX},
                                {"orientation": orientation+90,"distance":distX},
                                {"orientation": orientation,"distance":distY},
                            ]
                        }else{
                                            //                         45               -45             135            -135
                            var temp = orientation +180;
                            var arrayOrientation = [
                                {"orientation": temp,"distance":distY},
                                {"orientation": temp-90,"distance":distX},
                                {"orientation": temp+90,"distance":distX},
                                {"orientation": temp-180,"distance":distY},
                            ]
                        }
                        var temp = [e.latLng.lng() ,e.latLng.lat()];
                        var direction = turf.bearing(turf.point(coord),turf.point(temp));
                        var goodDirection = 0;
                        var goodDistance = 0;
                        arrayOrientation.forEach(element => {
                            if(direction>=element.orientation-45 && direction<element.orientation+45){
                                goodDirection = element.orientation;
                                goodDistance = element.distance;
                            }                                    
                        });
                        
                        tempModule = turf.transformTranslate(tempModule,goodDistance,goodDirection);
                        var tempMod= {
                            'type': 'Feature',
                            'properties':{ 
                                'id' : 'pv module',
                                'name':'new',
                            },
                            'geometry': {
                                'type': 'Polygon',
                                'coordinates': tempModule.coordinates
                            }
                        
                        };
                      
                        this.pvGrid.features.push(tempMod);
                        
                        this.pvFields.nbModule = this.pvGrid.features.length*parseFloat(this.parametreFields['Nombre de Module en Longueur'])*parseFloat(this.parametreFields['Nombre de Module en Largeur']);
                        this.pvFields.puissance= this.pvFields.nbModule*parseFloat(this.parametreFields['Puissance'])/1000;
                        this.pvFields.champ = this.pvGrid;
                        
                        this.map.data.addGeoJson(tempMod);

                        tempModule = null;
                        flagChanged(this);
                    }
                });

                this.map.data.addListener('click', (e) => {
                    if (isAddition) {
                        if(document.getElementById("+").className=="active"){
                            coord = [e.latLng.lng(), e.latLng.lat()];

                            e.feature.toGeoJson(geojson => {
                                tempModule = geojson.geometry;
                            });
                        }

                    }

                    if (isRemove) {
                        removeFromPvGrid(e);
                        this.pvFields.nbModule = this.pvGrid.features.length*parseFloat(this.parametreFields['Nombre de Module en Longueur'])*parseFloat(this.parametreFields['Nombre de Module en Largeur']);
                        this.pvFields.puissance= this.pvFields.nbModule*parseFloat(this.parametreFields['Puissance'])/1000;
                        this.pvFields.champ = this.pvGrid;
                                
                        this.map.data.remove(e.feature);
                    }
                });

                removePvLink.onclick = () => {
                    tempModule = null;

                    isRemove = !isRemove;
                    isAddition = false;

                    removePvLink.classList.toggle("inactive");
                    removePvLink.classList.toggle("active");
                    addPvLink.classList.remove('active');
                    addPvLink.classList.add('inactive');
                }

                addPvLink.onclick =() => {
                    isAddition = !isAddition;
                    isRemove = false;

                    addPvLink.classList.toggle("inactive");
                    addPvLink.classList.toggle("active");
                    removePvLink.classList.remove('active');
                    removePvLink.classList.add('inactive');
                }
                this.map.data.addListener('mousedown', e => {
                    // Temp remove the feature from this.pvGrid
                    if (isAddition || isRemove) {
                        return;
                    }
                    removeFromPvGrid(e);                  
                });

                this.map.data.addListener('mouseup', e => {
                    if (isAddition || isRemove) {
                        return;
                    }
                    // Add again the feature to the this.pvGrid                   
                    e.feature.toGeoJson(geojson => {
                        this.pvGrid.features.push(geojson);
                    }); 
                })

                //Gere le drag and drop du nouveau polygon
                this.map.data.addListener('setgeometry', e => {
                    const oldCoords = getCoordinates(e.oldGeometry);
                    const newCoords = getCoordinates(e.newGeometry);                  

                    const shiftMatrix = [];
                    for (let i = 0; i < oldCoords.length; i++) {
                        const coordinatesTmpStart = oldCoords[i];
                        const coordinatesTmpEnd = newCoords[i];
                        shiftMatrix.push([coordinatesTmpEnd[0] - coordinatesTmpStart[0], coordinatesTmpEnd[1] - coordinatesTmpStart[1]])
                    }
                    
                    //Clean le pvGrid de la map
                    this.map.data.forEach(feature => {                       
                        if (feature !== e.feature & feature.getProperty('name')==='new') {
                            this.map.data.remove(feature);
                        }
                    });
                                                           
                    // Update geometry
                    this.pvGrid.features.forEach(feature => {
                        const oldCoordinates = feature.geometry.coordinates[0];
                        const newCoordinates = [];
                        shiftMatrix.forEach((elem, index) => {
                            newCoordinates.push([Number(oldCoordinates[index][0]) + Number(elem[0]), Number(oldCoordinates[index][1]) + Number(elem[1])])
                        })
                        feature.geometry.coordinates = [ newCoordinates ];                       
                    });
                    this.map.data.addGeoJson(this.pvGrid);                                                                     
                });

                this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(menu);
            }
        }
    }

</script>
<style>
.button-control {
    background-color: white;
    margin: 5px;
}

.button-control > button {
    height: 24px;
    background: rgb(255, 255, 255) none repeat scroll 0% 0% padding-box;
    padding: 3px 4px 4px 4px;
}

.control-left {
    font-size: 20px;
}

  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
  }

  .modal {
    box-shadow: 2px 2px 20px 1px;
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    width: 85%;
    margin-left: 7.5%;
    padding: 3rem;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: flex;
  }

  .modal-header {
    position: relative;
    border-bottom: 1px solid #eeeeee;
    color: #4AAE9B;
    justify-content: space-between;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    flex-direction: column;
    justify-content: flex-end;
  }

  .modal-body {
    position: relative;
    padding: 20px 10px;
  }

  .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    border: none;
    font-size: 20px;
    padding: 10px;
    cursor: pointer;
    font-weight: bold;
    color: #4AAE9B;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #4AAE9B;
    border: 1px solid #4AAE9B;
    border-radius: 2px;
  }
</style>